import React from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';

interface VariationMetadataProps {
  metadata: any;
  compact?: boolean;
}

export const VariationMetadata: React.FC<VariationMetadataProps> = ({ metadata, compact = false }) => {
  if (!metadata) return null;

  if (compact) {
    return (
      <>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {metadata.character_count && (
            <Typography variant="caption" color="text.secondary">
              Characters: {metadata.character_count}
            </Typography>
          )}
          {metadata.tone && (
            <Typography variant="caption" color="text.secondary">
              Tone: {metadata.tone}
            </Typography>
          )}
          {metadata.hashtags && Array.isArray(metadata.hashtags) && metadata.hashtags.length > 0 && (
            <Typography variant="caption" color="text.secondary">
              Hashtags: {metadata.hashtags.join(', ')}
            </Typography>
          )}
        </Box>
      </>
    );
  }

  return (
    <Box sx={{ mt: 'auto' }}>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {metadata.hashtags && Array.isArray(metadata.hashtags) && metadata.hashtags.length > 0 && (
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
              Hashtags:
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {metadata.hashtags.map((tag: string, idx: number) => (
                <Chip
                  key={idx}
                  label={tag}
                  size="small"
                  variant="outlined"
                  sx={{
                    fontSize: '0.7rem',
                    color: '#6C63FF',
                    borderColor: '#6C63FF',
                    '&:hover': {
                      backgroundColor: 'rgba(108, 99, 255, 0.08)',
                      borderColor: '#6C63FF',
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        )}
        {metadata.call_to_action && (
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
              Call to Action:
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {metadata.call_to_action}
            </Typography>
          </Box>
        )}
        {metadata.character_count && (
          <Box>
            <Typography variant="caption" color="text.secondary">
              Character Count: {metadata.character_count}
            </Typography>
          </Box>
        )}
        {metadata.tone && (
          <Box>
            <Typography variant="caption" color="text.secondary">
              Tone: <strong>{metadata.tone}</strong>
            </Typography>
          </Box>
        )}
        {metadata.optimization_notes && (
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
              Optimization Notes:
            </Typography>
            <Typography variant="caption" sx={{ fontStyle: 'italic' }}>
              {metadata.optimization_notes}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

